import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import JobDetailHero from './sections/JobDetailHero';
import JobDetailContent from './sections/JobDetailContent';
import { Job } from '../../types/jobs';
import { fetchJobBySlug } from '../../lib/careers';

const JobDetailPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const [job, setJob] = useState<Job | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadJob = async () => {
      if (!slug) {
        setError('Job not provided');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const jobData = await fetchJobBySlug(slug);

        if (jobData) {
          setJob(jobData);
        } else {
          setError('Job not found');
        }
      } catch (err) {
        setError('Failed to load job details');
        console.error('Error loading job:', err);
      } finally {
        setLoading(false);
      }
    };

    loadJob();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto mb-4"></div>
          <p className="text-gray-400">Loading job details...</p>
        </div>
      </div>
    );
  }

  if (error || !job) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-display font-semibold text-white mb-4">
            {error || 'Job Not Found'}
          </h1>

          <p className="text-gray-400">
            {error === 'Job not found'
              ? "The job you're looking for doesn't exist or is no longer available."
              : 'Please try again later.'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-black">
      <JobDetailHero job={job} />
      <JobDetailContent job={job} />
    </main>
  );
};

export default JobDetailPage;